import {
    deleteTravelExpensesSagaWatcher,
    getMoreTravelExpensesSagaWatcher,
} from 'modules/travelExpenses/components/TravelExpensesTable/sagas';

export const travelExpenseSagas = [
    getMoreTravelExpensesSagaWatcher,
    deleteTravelExpensesSagaWatcher,
];
